import { useState } from "react";
import { Container } from "../components/ui/Container";
import { assetUrl, siteUrl } from "../wordpress";
import "./CartPage.css";

const UNIT_PRICE = 21;

function formatPrice(value: number): string {
	return new Intl.NumberFormat("ca-ES", {
		style: "currency",
		currency: "EUR",
	}).format(value);
}

/**
 * Representació local de la cistella de WooCommerce. En producció, la mateixa
 * ruta continua sent servida pel template Shell i per les dades reals de la
 * sessió; aquesta versió permet revisar el layout sense un WordPress local.
 */
export function CartPage() {
	const [quantity, setQuantity] = useState(1);
	const [hasProduct, setHasProduct] = useState(true);
	const subtotal = UNIT_PRICE * quantity;

	return (
		<article className="cart-page">
			<Container>
				<header className="cart-page__header">
					<p className="cart-page__kicker">Botiga</p>
					<h1>Cistella</h1>
				</header>

				{hasProduct ? (
					<div className="cart-page__layout">
						<form className="woocommerce-cart-form" onSubmit={(event) => event.preventDefault()}>
							<table className="shop_table shop_table_responsive cart woocommerce-cart-form__contents">
								<thead>
									<tr>
										<th className="product-remove"><span className="visually-hidden">Elimina</span></th>
										<th className="product-thumbnail"><span className="visually-hidden">Imatge</span></th>
										<th className="product-name">Producte</th>
										<th className="product-price">Preu</th>
										<th className="product-quantity">Quantitat</th>
										<th className="product-subtotal">Subtotal</th>
									</tr>
								</thead>
								<tbody>
									<tr className="cart_item">
										<td className="product-remove">
											<button className="remove" type="button" onClick={() => setHasProduct(false)} aria-label="Elimina Cartografia de l’estrany de la cistella">×</button>
										</td>
										<td className="product-thumbnail">
											<a href={siteUrl("/producte/cartografia-de-lestrany-mapa-i-finestres/")}>
												<img src={assetUrl("/assets/finesterres.jpeg")} alt="Coberta de Cartografia de l’estrany, Mapa I: Finestres" />
											</a>
										</td>
										<td className="product-name" data-title="Producte">
											<a href={siteUrl("/producte/cartografia-de-lestrany-mapa-i-finestres/")}>Cartografia de l’estrany – Mapa I: Finestres</a>
										</td>
										<td className="product-price" data-title="Preu">{formatPrice(UNIT_PRICE)}</td>
										<td className="product-quantity" data-title="Quantitat">
											<label className="visually-hidden" htmlFor="cart-quantity">Quantitat</label>
											<input id="cart-quantity" className="qty" type="number" min="1" max="99" value={quantity} onChange={(event) => setQuantity(Math.max(1, Number(event.target.value) || 1))} />
										</td>
										<td className="product-subtotal" data-title="Subtotal">{formatPrice(subtotal)}</td>
									</tr>
								</tbody>
							</table>
						</form>

						<aside className="cart-page__totals" aria-labelledby="cart-totals-title">
							<h2 id="cart-totals-title">Total de la cistella</h2>
							<div className="cart-page__total-row"><span>Subtotal</span><strong>{formatPrice(subtotal)}</strong></div>
							<div className="cart-page__total-row cart-page__total-row--final"><span>Total</span><strong>{formatPrice(subtotal)}</strong></div>
							<button className="cart-page__checkout" type="button">Finalitza la compra</button>
						</aside>
					</div>
				) : (
					<div className="cart-page__empty" role="status">
						<p>La cistella està buida.</p>
						<a href={siteUrl("/botiga/")}>Continua comprant</a>
					</div>
				)}
			</Container>
		</article>
	);
}
